/**
 * Convert line-breaks from HTML break tags.
 */
var newLineToBreakTag = function newLineToBreakTag() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/\\n/g, '<br />');
};

export default newLineToBreakTag;